module.exports = __webpack_public_path__ + "static/media/map_mundi_no_vida.fdf8ea00.png";